import axios from "axios";
import {headers} from "@/services/headers"
import {ThunkAction} from "@reduxjs/toolkit";
import {RootState} from "../store";
import {
    getErrors,
    loading,
    setAnnouncement,
    setAnnouncementDeleted, setAnnouncementRecipients,
    setAnnouncements,
    setPaginator
} from "@/reducers/announcements";
import toast from "react-hot-toast";

export const GetAnnouncement = (eventCode?: string, query?: string, page = 1):  ThunkAction<void, RootState, unknown, any> => async (dispatch: any) => {
    dispatch(loading(true))

    return axios
        .get(process.env.REACT_APP_BASE_URL + '/org/events/' + eventCode + '/outboxes?filter[search]=' + query + '&page=' + page, {
            headers: headers()
        }).then((response) => {
            dispatch(setAnnouncements(response.data.data));
            dispatch(setPaginator(response.data.meta));

            dispatch(loading(false))
        }).catch((error: any) => {
            const {errors, message} = error.response.data.error;

            dispatch(getErrors({
                errorMsg: message,
                errors: errors,
            }));

            dispatch(loading(false))
        });
};

export const ShowAnnouncement = (eventCode?: string, outboxCode?: string):  ThunkAction<void, RootState, unknown, any> => async (dispatch: any) => {
    dispatch(loading(true))

    return axios
        .get(process.env.REACT_APP_BASE_URL + '/org/events/' + eventCode + '/outboxes/' + outboxCode, {
            headers: headers()
        }).then((response) => {
            dispatch(setAnnouncement(response.data.data));

            dispatch(loading(false))
        }).catch((error: any) => {
            const {errors, message} = error.response.data.error;

            dispatch(getErrors({
                errorMsg: message,
                errors: errors,
            }));

            dispatch(loading(false))
        });
};

export const GetAnnouncementRecipient = (eventCode?: string, announcementCode?: string, query?: string, page = 1):  ThunkAction<void, RootState, unknown, any> => async (dispatch: any) => {
    dispatch(loading(true))

    return axios
        .get(process.env.REACT_APP_BASE_URL + '/org/events/' + eventCode + '/outboxes/' + announcementCode + '/recipients?filter[search]=' + query + '&page=' + page, {
            headers: headers()
        }).then((response) => {
            dispatch(setAnnouncementRecipients(response.data.data));
            dispatch(setPaginator(response.data.meta));

            dispatch(loading(false))
        }).catch((error: any) => {
            const {errors, message} = error.response.data.error;

            dispatch(getErrors({
                errorMsg: message,
                errors: errors,
            }));

            dispatch(loading(false))
        });
};

export const StoreAnnouncement = (eventId: number, attributes: {subject: string, body: string, type: string, channel: string, recipient: any}):  ThunkAction<void, RootState, unknown, any> => async (dispatch: any) => {
    dispatch(loading(true))

    return axios
        .post(process.env.REACT_APP_BASE_URL + '/org/events/' + eventId + '/outboxes', attributes, {
            headers: headers()
        }).then((response) => {
            dispatch(setAnnouncement(response.data.data));

            dispatch(loading(false))
        }).catch((error: any) => {
            const {errors, message} = error.response.data.error;

            dispatch(getErrors({
                errorMsg: message,
                errors: errors,
            }));

            dispatch(loading(false))
        });
};

export const SendAnnouncement = (eventId: number, outboxId: number):  ThunkAction<void, RootState, unknown, any> => async (dispatch: any) => {
    dispatch(loading(true))

    return axios
        .post(process.env.REACT_APP_BASE_URL + '/org/events/' + eventId + '/outboxes/' + outboxId + '/send', {}, {
            headers: headers()
        }).then((response) => {
            toast.success("Berhasil mengirim pengumuman");

            dispatch(loading(false))
        }).catch((error: any) => {
            const {errors, message} = error.response.data.error;

            dispatch(getErrors({
                errorMsg: message,
                errors: errors,
            }));

            dispatch(loading(false))
        });
};

export const DeleteAnnouncement = (eventId: number, affiliatorId: number):  ThunkAction<void, RootState, unknown, any> => async (dispatch: any) => {
    dispatch(loading(true))

    return axios
        .delete(process.env.REACT_APP_BASE_URL + '/org/events/' + eventId + '/outboxes/' + affiliatorId, {
            headers: headers()
        }).then(() => {
            dispatch(setAnnouncementDeleted(affiliatorId));

            dispatch(loading(false))
            toast.success('Berhasil menghapus pengumuman');
        }).catch((error: any) => {
            const {errors, message} = error.response.data.error;

            dispatch(getErrors({
                errorMsg: message,
                errors: errors,
            }));

            dispatch(loading(false))
        });
};
